<template>
  <v-switch
    :outlined="!disabled"
    :filled="disabled"
    v-model="value"
    :label="label"
    :persistent-hint="typeof hint !== 'undefined'"
    :hint="hint"
    @change="$emit('update:inputData', { value });$root.$emit('changeSwitch', { value })"
    :rules="rules"
    :disabled="disabled"
    :true-value="params.truevalue"
    :false-value="params.falsevalue"
  >
  </v-switch>
</template>

<script>
export default {
  props: {
    label: String,
    hint: String,
    placeholder: String,
    disabled: Boolean,
    initialValue: {
      required: false,
    },
    inputData: Object,
    rules: {
      type: Array,
      default: () => [],
    },
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      value: false,
    };
  },
  created() {
    const { initialValue, params: { truevalue, falsevalue } } = this;

    let emitValue = falsevalue || false;
    if (typeof initialValue === 'boolean') {
      emitValue = initialValue ? (truevalue || true) : (falsevalue || false);
    }
    if (typeof initialValue !== 'undefined') {
      this.value = initialValue;
    }
    // emit inputData to initialize switch value in context
    this.$emit('update:inputData', { value: emitValue });
  },
  beforeDestroy() {
    this.$emit('update:inputData', {});
  },
};
</script>

<style lang="scss">
  .v-input--selection-controls.v-input--switch .v-input__slot .v-label {
    flex: 0 1 auto;
  }
  .v-label{
    font-size: 0.9375rem;
  }
</style>
